import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AdminMediaListResponse } from '~client/model/admin/admin-media-list-response';
import { MediaResponse } from '~client/model/media-response';
import { MediaType } from '~client/model/media-type';

/* Admin APIs to login/logout */
export class MediaAdminController extends BaseController {
  /* Returns a list of media */
  public getMediaList$(
    descriptionSearch: string,
    mediaType: MediaType,
  ): Observable<AdminMediaListResponse> {
    return this.get$('/media', { descriptionSearch, mediaType });
  }

  /* Allows the admin to upload media */
  public uploadMedia$(formData: FormData): Observable<MediaResponse> {
    return this.post$('/media/upload', formData);
  }

  /* Allows the admin to upload transactions for media */
  public uploadTranslation$(formData: FormData): Observable<MediaResponse> {
    return this.post$('/media/uploadTranslation', formData);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/media-admin-controller.ts